module.exports = __webpack_public_path__ + "img/ftm-oceanBlue.614dcab5.png";